import { render, staticRenderFns } from "./VaultCategories.vue?vue&type=template&id=066260dd&scoped=true&"
import script from "./VaultCategories.vue?vue&type=script&lang=ts&"
export * from "./VaultCategories.vue?vue&type=script&lang=ts&"
import style0 from "./VaultCategories.vue?vue&type=style&index=0&id=066260dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066260dd",
  null
  
)

export default component.exports